import { BasePlugin } from '../base'
import mdcSelect from './mdc-select.vue'

export { mdcSelect }

export default BasePlugin({
  mdcSelect
})
